import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification, message } from 'antd'
import {
  login,
  currentAccount,
  logout,
  getUsers,
  getRoles,
  enableUser,
  disableUser,
  uploadCSV,
  editUser,
  kickOutUser,
  deleteMultiUsers,
  disableMultiUsers,
  kickoutMulitpleUsers,
  assignORunassignMulitpleUsers,
} from 'services/user'
import { initChat, pubnubPublish } from 'services/virtual/chat'
import actions from './actions'

export function* LOGIN({ payload }) {
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(login, email, password)
  if (success) {
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in to Clean UI React Admin Template!',
    })
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(currentAccount)
  if (response) {
    const { uid: id, email, photoURL: avatar } = response
    yield put({
      type: 'user/SET_STATE',
      payload: {
        id,
        name: id === 'YAtiMJg0MHNLwnKNBqWqDIHIneq1' ? 'Wiz Administrator' : 'Wiz Contributer',
        email,
        avatar,
        role: id === 'YAtiMJg0MHNLwnKNBqWqDIHIneq1' ? 'admin' : 'contributer',
        authorized: true,
      },
    })
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  yield call(logout)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
    },
  })
}

export function* GET_USERS(data) {
  try {
    const state = yield select()
    const {
      user: { size, page, search, sort },
      virtualUser: { accessToken },
    } = state
    // const{count, page, search, sort}=data.payload
    const querydata = yield call(getUsers, {
      size,
      page,
      search,
      sort,
      accessToken,
      ...data.payload,
    })
    if (querydata.status === 200) {
      // let finalData = querydata.data
      // const dataLength = Object.keys(finalData).length
      // if(currentPage !== 0)
      // {
      //   finalData = { ...directoryData , ...querydata.data}
      // }
      yield put({
        type: actions.SET_STATE,
        payload: {
          // users: Object.values(querydata.data),
          users: Object.values(querydata.data.users),
          page: querydata.data.page,
          totalCount: querydata.data.totalCount,
          selectedRowKeys: [],
          loading: false,
          // users: Object.values(querydata.data),
          userLoading: false,
        },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response?.status}:${err.response.data.message}`)
  }
}

export function* GET_ROLES() {
  try {
    const querydata = yield call(getRoles)
    if (querydata.status === 200) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          roles: Object.values(querydata.data),
        },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response?.status}:${err.response.data.message}`)
  }
}

export function* GET_SINGLEUSER(data) {
  try {
    const state = yield select()
    const {
      user: { size, page, search, sort },
      virtualUser: { accessToken },
    } = state
    // const{count, page, search, sort}=data.payload
    const querydata = yield call(getUsers, {
      size,
      page,
      search,
      sort,
      accessToken,
      ...data.payload,
    })
    if (querydata.status === 200) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          singleUser: querydata.data[data.payload.key],
          editorLoading: false,
        },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* ENABLE_USER(data) {
  try {
    const state = yield select()
    const {
      user: { users },
    } = state
    const userstatus = yield call(enableUser, {
      ...data.payload,
    })
    const currentIndex = users.findIndex(element => element.id === data.payload.key)
    users[currentIndex].active_status = true
    if (userstatus.status === 200) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userLoading: false,
          users,
        },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* DISABLE_USER(data) {
  try {
    const state = yield select()
    const {
      user: { users },
    } = state
    const userstatus = yield call(disableUser, {
      ...data.payload,
    })
    if (userstatus.status === 200) {
      const currentIndex = users.findIndex(element => element.id === data.payload.key)
      console.log('DDDDDDDDDDDDDDDDDDDDDDDDDDD')
      console.log(currentIndex)
      users[currentIndex].active_status = false
      yield put({
        type: actions.SET_STATE,
        payload: {
          userLoading: false,
        },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* KICK_OUT_USER(data) {
  try {
    const state = yield select()
    const {
      virtualSetup: { pubnub },
      user: { users },
      virtualUser: { id },
    } = state

    let pubnubNew = ''
    if (pubnub === null) {
      pubnubNew = yield call(initChat, 'wiz365-admin')
      yield put({
        type: actions.SET_STATE,
        payload: {
          pubnub: pubnubNew,
        },
      })
    }
    console.log(data, process.env.REACT_APP_NOTIFICATION_CHANNEL)
    const publishData = {
      channelID: data.payload.key,
      message: { message: 'Kicked Out', type: 'kick_out', publisher: id },
      pubnub: pubnub === null ? pubnubNew : pubnub,
    }
    yield call(pubnubPublish, publishData)
    message.success('User Kicked Out Successfully')
    const userstatus = yield call(kickOutUser, {
      ...data.payload,
    })
    if (userstatus.status === 200) {
      const currentIndex = users.findIndex(element => element.id === data.payload.key)
      users[currentIndex].active_status = false
      yield put({
        type: actions.SET_STATE,
        payload: {
          userLoading: false,
        },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

//   try {
//     const state = yield select()
//     const {
//       user: { users },
//         virtualSetup: { pubnub },
//       } = state

//       let pubnubNew = ''
//       if (pubnub === null) {
//         pubnubNew = yield call(initChat, 'wiz365-admin')
//         yield put({
//           type: actions.SET_STATE,
//           payload: {
//             pubnub: pubnubNew,
//           },
//         })
//       }

//     const publishData = {
//       channelID: data.payload.key,
//       message: 'kick_out',
//       pubnub,
//     }
//     yield call(pubnubPublish, publishData)

//     const userstatus = yield call(kickOutUser, {
//       ...data.payload,
//     })
//     if (userstatus.status === 200) {
//       const currentIndex = users.findIndex(element => element.id === data.payload.key)
//       users[currentIndex].active_status = false
//       yield put({
//         type: actions.SET_STATE,
//         payload: {
//           userLoading: false,
//         },
//       })
//     }
//   } catch (err) {
//     console.log(err.response)
//     message.error(`${err.response.status}:${err.response.data.message}`)
//   }
// }

export function* UPLOAD_CSV(data) {
  try {
    const state = yield select()
    const {
      user: { csvBase64 },
      virtualUser: { accessToken },
    } = state

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
        data.payload.onProgress({ percent: percentCompleted })
      },
    }

    const querydata = yield call(uploadCSV, {
      csvBase64,
      token: accessToken,
      file: data.payload.file,
      config,
    })
    if (querydata.status === 200) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userLoading: false,
        },
      })
      data.payload.onSuccess('ok')
      message.success('Congratulations! Your entry has been succesfully submitted.')
      console.log('SUCCESS')
      console.log(querydata)
      yield put({
        type: actions.GET_USERS,
        payload: {},
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(
      `Oops! There seems to be an issue with submitting your entry. Check your internet and try again`,
    )
  }
}

export function* EDIT_USER(data) {
  try {
    const state = yield select()
    const {
      virtualUser: { accessToken },
      registerVirtualUser: { id },
      user: { users },
    } = state
    const result = yield call(editUser, { ...data.payload, token: accessToken, id })
    if (result.status === 200) {
      const currentIndex = users.findIndex(element => element.id === id)
      users[currentIndex] = data.payload
      yield put({
        type: 'registerVirtualuser/SET_STATE',
        payload: {
          isUserModalVisible: false,
        },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* MULTI_DELETE_USER(data) {
  try {
    const userstatus = yield call(deleteMultiUsers, {
      ...data.payload,
    })
    if (userstatus.status === 200) {
      message.success('Users are deleted successfully')
      yield put({
        type: actions.GET_USERS,
        payload: {},
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* MULTI_DISABLE_USER(data) {
  try {
    const userstatus = yield call(disableMultiUsers, {
      ...data.payload,
    })
    if (userstatus.status === 200) {
      message.success('Users are disabled successfully')
      yield put({
        type: actions.GET_USERS,
        payload: {},
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* MULTI_KICKOUT_USER(data) {
  try {
    const userstatus = yield call(kickoutMulitpleUsers, {
      ...data.payload,
    })
    if (userstatus.status === 200) {
      message.success('Users are kicked out successfully')
      yield put({
        type: actions.GET_USERS,
        payload: {},
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* MULTI_ROLE_ASSIGN_OR_UNASSIGN_USER(data) {
  try {
    const userstatus = yield call(assignORunassignMulitpleUsers, {
      ...data.payload,
    })
    if (userstatus.status === 200) {
      message.success(`Users are ${data.payload.type}ed successfully`)
      yield put({
        type: actions.GET_USERS,
        payload: {},
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
    takeEvery(actions.GET_USERS, GET_USERS),
    takeEvery(actions.GET_ROLES, GET_ROLES),
    takeEvery(actions.GET_SINGLEUSER, GET_SINGLEUSER),
    takeEvery(actions.ENABLE_USER, ENABLE_USER),
    takeEvery(actions.DISABLE_USER, DISABLE_USER),
    takeEvery(actions.UPLOAD_CSV, UPLOAD_CSV),
    takeEvery(actions.EDIT_USER, EDIT_USER),
    takeEvery(actions.KICK_OUT_USER, KICK_OUT_USER),
    takeEvery(actions.MULTI_DELETE_USER, MULTI_DELETE_USER),
    takeEvery(actions.MULTI_DISABLE_USER, MULTI_DISABLE_USER),
    takeEvery(actions.MULTI_KICKOUT_USER, MULTI_KICKOUT_USER),
    takeEvery(actions.MULTI_ROLE_ASSIGN_OR_UNASSIGN_USER, MULTI_ROLE_ASSIGN_OR_UNASSIGN_USER),
  ])
}
